import { Box, Flex, styled } from '@driftt/dds'

export const StyledScrollbarHiddenContainer = styled(Flex, {
  overflowY: 'scroll',
  width: '100%',
  height: '100%',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
})

export const StyledInfoContainer = styled(Box, {
  backgroundColor: '$blue1',
  border: 'solid 1px $blue3',
  borderRadius: '3px',
  padding: '12px',
})

export const StyledList = styled('ul', {
  listStyleType: 'disc',
  paddingLeft: '20px',
})
